import React, { useState } from "react";
import cameraIcon from "../../assets/camera.png";
import { Modal, ModalBody, ModalHeader, Spinner } from "react-bootstrap";
import { Field, Form, Formik } from "formik";
import * as Yup from "yup";
import "./modal.css";
import closeIcon from "../../assets/close.png";
import {
  updateInvoiceAction,
  uploadInvoice,
} from "../../redux/actions/orderActions";
import { useEffect } from "react";
import { useDispatch } from "react-redux";
import ErrorMsg from "../form/errorMsg";
import ErrorPopup from "../Popups/ErrorPopup";
import SuccessPopup from "../Popups/SuccessPopUp";
import { getFileExtension } from "../utilites/helper";
import { Document, Page } from "react-pdf";

const UploadInvoiceImageModal = ({
  show,
  closeFunc,
  formData,
  orderId,
  fetchOrderList,
}) => {
  const dispatch = useDispatch();
  const [images, setImages] = useState([]);
  const [loading, setLoading] = useState(false);
  const [disable, setDisable] = useState(true);
  const [img, setImg] = useState(null);
  const [imgLoading, setImgLoading] = useState(false);
  const [showErrorPopup, setShowErrorPopup] = useState(false);
  const [showErrorMsg, setShowErrorMsg] = useState("");
  const [showSuccessPopup, setShowSuccessPopup] = useState(false);
  const [showSuccessMsg, setShowSuccessMsg] = useState("");
  const currentDate = new Date().toISOString().split("T")[0];

  useEffect(() => {
    if (img != null && img.trim() != "") {
      setDisable(false);
    } else {
      setDisable(true);
    }
  }, [img]);

  const handleDoc1Change = (e) => {
    setImgLoading(true);
    dispatch(
      uploadInvoice(
        e.target.files[0],
        onImageUploadSuccess,
        onImageUploadError,
      ),
    );
  };

  const onImageUploadSuccess = (data) => {
    console.log(data);
    setImgLoading(false);
    setImg(data.data.data.filePath);
  };

  const onImageUploadError = (err) => {
    setImgLoading(false);
    console.log(err);
  };

  const initialValues = {
    profileImage: "",
    invoice_id: "",
    invoice_date: "",
  };
  const loginSchema = Yup.object().shape({
    // profileImage: Yup.mixed().required("Upload an Image"),
  });
  const onSubmit = (values, { resetForm }) => {
    // resetForm();
    values["products"] = formData;
    values["order_id"] = orderId;
    values["url"] = img;
    dispatch(updateInvoiceAction(values, onSuccess, onError));
    // onSuccess();
  };

  const timeOutFnc = () => {
    setShowSuccessPopup(false);
    setImages([]);
    fetchOrderList();
  };

  const onSuccess = (data) => {
    console.log(data);
    closeFunc();
    setImg(null);
    setShowSuccessPopup(true);
    const message = data.data.message;
    const msg_updated = message.charAt(0).toUpperCase() + message.slice(1);
    setShowSuccessMsg(msg_updated);
    setTimeout(timeOutFnc, 2000);
  };

  const closeErrorPopup = () => {
    setShowErrorPopup(false);
    closeFunc();
    setImg(null);
    setImages([]);
  };

  const onError = (err) => {
    console.log(err);
    setShowErrorPopup(true);
    const str = err.data.message;
    const str_modify = str.charAt(0).toUpperCase() + str.slice(1);
    setShowErrorMsg(str_modify);
  };

  return (
    <>
      <Modal
        centered
        show={show}
        onHide={() => {
          closeFunc();
          setImg(null);
          setImages([]);
        }}
        dialogClassName="upload-invoice-image col-6 mx-auto"
      >
        <ModalHeader>
          <span className="fn_Nunito fw_600 fs_14 Medium_Purple my- px-0 text-uppercase">
            Upload Invoice
          </span>
        </ModalHeader>
        <ModalBody>
          <div>
            <Formik
              initialValues={initialValues}
              onSubmit={onSubmit}
              validationSchema={loginSchema}
            >
              {({ formik, values, setFieldValue }) => {
                return (
                  <Form className="">
                    <div className=" px-3">
                      {/* <div>
                      <span className="text_red fs_14">Note :</span>
                    </div> */}
                      <div className="d-flex gap-2">
                        <div className="w-100">
                          <label className="fn_Nunito color_262c3d ">
                            Invoice Number
                          </label>
                          <Field name={"invoice_id"}>
                            {({ field, meta }) => (
                              <input
                                {...field}
                                placeholder="Enter invoice number"
                                id={"invoice_id"}
                                className={
                                  "w-100 invoice-input-field ps-2 text-capitalize"
                                }
                              />
                            )}
                          </Field>
                          <ErrorMsg name="invoice_id" />
                        </div>
                        <div>
                          <label className="fn_Nunito color_262c3d ">
                            Invoice Date
                          </label>
                          <div className=" d-flex ">
                            <div className=" d-flex align-items-center  py-1 px-3 amount_input_container ">
                              <Field name={"invoice_date"}>
                                {({ field, form }) => (
                                  <input
                                    type="date"
                                    {...field}
                                    placeholder="Select Date"
                                    className="amount_input py-1 ms-1"
                                    name="invoice_date"
                                    max={currentDate}
                                  />
                                )}
                              </Field>
                            </div>
                          </div>
                          <ErrorMsg name="invoice_date" />
                        </div>
                      </div>

                      <div className="d-flex flex-column flex-lg-row justify-content-center align-items-center px-4 mx-2 mt-3 gap-3  ">
                        {!img ? (
                          <>
                            {imgLoading ? (
                              <div className="d-flex justify-content-center align-items-center upload-invoice-image-container w-100">
                                <Spinner size="sm" />
                              </div>
                            ) : (
                              <div className="upload-invoice-image-container w-100">
                                <label
                                  className="w-100 h-100 d-flex justify-content-center align-items-center"
                                  htmlFor="invoice"
                                >
                                  <img
                                    src={cameraIcon}
                                    width="35px"
                                    height="35px"
                                  />
                                </label>
                                <input
                                  id="invoice"
                                  className="upload-document-input"
                                  type="file"
                                  name="file"
                                  // accept="pdf/*"
                                  onChange={(e) => handleDoc1Change(e)}
                                />
                              </div>
                            )}
                          </>
                        ) : (
                          <div className="w-100 upload-invoice-image-container position-relative">
                            <div
                              onClick={() => setImg(null)}
                              className={`upload_icon_close_container position-absolute top-0 end-0 m-1`}
                            >
                              <img
                                src={closeIcon}
                                alt="close icon"
                                width={20}
                                height={20}
                                className={`cursor_pointer mb-2  `}
                              />
                            </div>
                            {getFileExtension(img) === "pdf" ? (
                              <Document file={img}>
                                <Page pageNumber={1} width={410} />
                              </Document>
                            ) : (
                              <img
                                src={img}
                                alt="uploaded"
                                className="w-100 h-100" // Added h-100 (height: 100%)
                                style={{ objectFit: "cover" }}
                              />
                            )}
                          </div>
                        )}
                      </div>
                    </div>
                    <div className="d-flex justify-content-end mt-3 me-2 gap-2">
                      <div>
                        <button
                          className="modal-submit-btn text-white px-4 py-2 fs_12"
                          type="submit"
                          disabled={disable}
                        >
                          {loading && <Spinner size="sm" />}
                          <span className="px-3">submit</span>
                        </button>
                      </div>
                      <button
                        className="modal-close-btn px-3 py-1 fs_12"
                        type="button"
                        onClick={() => {
                          closeFunc();
                          setImg(null);
                          setImages([]);
                        }}
                      >
                        close
                      </button>
                    </div>
                  </Form>
                );
              }}
            </Formik>
          </div>
        </ModalBody>
      </Modal>
      <ErrorPopup
        show={showErrorPopup}
        title={showErrorMsg}
        handleClose={closeErrorPopup}
      />
      <SuccessPopup show={showSuccessPopup} title={showSuccessMsg} />
    </>
  );
};

export default UploadInvoiceImageModal;
